import React from 'react';

import { SortableElement, SortableHandle } from 'react-sortable-hoc';

const DragHandle = SortableHandle(() => {
  return (
    <div className="text-center">
      <div className="btn-xs btn btn-default dragMe">
        Hold here to move
      </div>
    </div>
  );
});

const ResultItem = SortableElement(({ styles, slot, feedId }) => {
  const { title, datetime, subTitle, description, result } = styles || {};
  return (
    <li className={`result-item ${slot.type}Slot`} style={result || {}}>
      { slot.type === 'ad' ? <DragHandle /> : null }
      <h5>
        <span className={`label label-${slot.type === 'ad' ? 'success' : 'primary'}`}>
          {slot.type === 'ad' ? slot.name : `Feed Slot ${feedId}`}
        </span>
      </h5>
      <div className="result-img">
        <img alt="company" src="https://via.placeholder.com/300?text=Company+Name" />
      </div>
      <div className="result-content">
        <div className="result-date" style={datetime || {}}>days / hours ago</div>
        <div className="result-title" style={title || {}}>
          Job Title
        </div>
        <div className="result-sub-title" style={subTitle || {}}>
          <span>Company</span> . <span>Location</span>
        </div>
        <div className="result-description" style={description || {}}>
          A job description is an internal document that clearly states the 
          essential job requirements, job duties, job responsibilities, and 
          skills required to perform a specific role. A more detailed job 
          description will cover how success is measured in the role 
          so it can be used during performance evaluations.
        </div>
      </div>
    </li>
  );
});

export default ResultItem;
